import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/home'
import Form from '../views/home/form'
import done from '../views/home/done'
import agent from '../views/home/agent'
import agent_done from '../views/home/agent-done'
import privacy from '../views/privacy/privacy'
import safety from '../views/safety/safety'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    meta: { title: '首页' },
    component: Home
  },
  {
    path: '/form',
    name: 'form',
    meta: { title: '报名' },
    component: Form
  },
  {
    path: '/agent',
    name: 'agent',
    meta: { title: '代报名' },
    component: agent
  },
  {
    path: '/agent-done',
    name: 'agent-done',
    meta: { title: '代报名成功' },
    component: agent_done
  },
  // {
  //   path: '/done',
  //   name: 'done',
  //   meta: { title: '报名结果' },
  //   component: done
  // },
  // {
  //   path: '/done',
  //   name: 'done',
  //   meta: { title: '报名结果' },
  //   component: done
  // },
  {
    path: '/done',
    name: 'done',
    meta: { title: '报名结果' },
    component: done
  },
  {
    path: '/privacy',
    name: 'privacy',
    meta: { title: '隐私政策' },
    component: privacy
  },
  {
    path: '/safety',
    name: 'safety',
    meta: { title: '安全须知' },
    component: safety
  }
]

const router = new VueRouter({
  mode: 'history',
  // base: process.env.BASE_URL,
  base: '/cnh5/',
  // base: '/xgj/',
  // base: '/sng/',
  routes
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js